import { createSlice } from "@reduxjs/toolkit";
import { getRateSummaryAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getRateSummarySlice = createSlice({
  name: "getRateSummary",
  initialState: data,
  reducers: {
   getRateSummarySlice(state) {
      state.isLoading = true;
    },
   getRateSummarySliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getRateSummarySliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getRateSummarySliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getRateSummaryHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(getRateSummaryAction.getRateSummarySlice());
    const response: any = await getRateSummaryAPI(data);
    
    dispatch(getRateSummaryAction.getRateSummarySliceSuccess(response));
  } catch (e: any) {
    dispatch(getRateSummaryAction.getRateSummarySliceFailure(e?.response?.data));
  }
};
export default getRateSummarySlice.reducer;
export const getRateSummaryAction = getRateSummarySlice.actions;
